export default __webpack_public_path__ + "static/media/francheville31.e047d0a0.jpg";